// extracted by mini-css-extract-plugin
module.exports = {"ProductArchive":"ProductArchive_ProductArchive__iitFV","intro":"ProductArchive_intro__f2ALU","list":"ProductArchive_list__k5UTJ"};